export enum ServerOptions {
  EMPTY = 'empty',
}
